module.exports = __webpack_public_path__ + "static/media/upgrade-performance-br.d338226f.png";